// extracted by mini-css-extract-plugin
export default {"userLogoPopup":"UserLogoPopup_userLogoPopup__yBBAt","button":"UserLogoPopup_button__gW1OA","text":"UserLogoPopup_text__gLqGP"};